import {useParams} from 'react-router-dom';

export default function ({fallback, children}) {
  const {organization} = useParams();
  return ['HYVINVOINT', 'MTLH', 'NASYLOMAT', 'SOLARISLOM', 'SEMESTER', 'PHT', 'PHTPERHE'].includes(organization) ? children : fallback;
}
